import { DocumentNode, gql } from "@apollo/client";
import { baseDynamicPageContent, baseGraphicElementContent } from "./base";

const DYNAMIC_PAGE = `
        ${baseDynamicPageContent},
        className,
        graphicElements {
            ${baseGraphicElementContent}
        }
    `;

const GET_DYNAMIC_PAGE_BY_ADMIN_ID = () => {
    return gql`
        query DynamicPageByAdminId($adminId: String!){
            result:dynamicPageByAdminId(adminId: $adminId) {
                ${DYNAMIC_PAGE}
            }
        }
    `;
};

export const GET_DYNAMIC_PAGE_BY_ADMIN_ID_PARAMS = (
    adminId?: string
): {
    query: DocumentNode;
    options: {
        skip: boolean;
        variables: {
            adminId: string;
        };
    };
} => {
    return {
        query: GET_DYNAMIC_PAGE_BY_ADMIN_ID(),
        options: {
            skip: adminId != null && adminId?.trim() !== "" ? false : true,
            variables: {
                adminId
            }
        }
    };
};
